<template>
  <section class="leftService2">
    <a :href="url + '?admin=false'" class="logo" target="_blank">
      <img src="https://static.iyw.cn/logo/appAbout.png" alt="" />
    </a>
    <p>创意和版权赋能中国制造</p>
    <p>的数智化平台</p>
    <ul class="serve">
      <li>流行趋势创意，激发畅销灵感</li>
      <li>产品设计实现，快速生成新品</li>
      <li>成果保护交易，护航创意资产</li>
    </ul>
  </section>
</template>

<script>
export default {
  data() {
    return {
      url: process.env.VUE_APP_PORTAL
    }
  }
};
</script>

<style lang="scss">
.leftService2 {
  width: 280px;
  height: 540px;
  background-image: url(../../../assets/img/left2.png);
  background-size: cover;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  overflow: hidden;
  .logo {
    display: block;
    width: 94px;
    height: auto;
    margin: 30px 0 64px 30px;
    img {
      width: 100%;
    }
  }
  p {
    font-size: 20px;
    font-weight: 600;
    color: #222222;
    line-height: 32px;
    margin-left: 30px;
  }
  .serve {
    padding: 24px 0 0 30px;
    li {
      color: $textColor;
      margin-bottom: 28px;
      font-size: 14px;
      line-height: 14px;
      &::before {
        content: '';
        display: inline-block;
        width: 16px;
        height: 16px;
        background: url('../../../assets/img/icon.png') no-repeat;
        background-size: 100%;
        margin-right: 10px;
        vertical-align: middle;
      }
    }
  }
}
</style>
